import { ref } from 'vue'
import { useRouter } from 'vue-router'
import { createSharedComposable } from '@vueuse/core'
import { deleteCalibrationSession as apiDeleteCalibrationSession, type CalibrationSession } from '@/api/calibration'
import alertDialog from '@/components/alertDialog'
import i18n from '@/i18n'
import useTicketRouteParams from '@/composables/useTicketRouteParams'
import { session } from '@/composables/useSession'
import { track } from '@/utils/analytics'
import useTasks from '@/composables/useTasks'


export default createSharedComposable(() => {
  const router = useRouter()
  const { calibrationSessionId } = useTicketRouteParams()
  const { canSeeCalibrations, getCalibrationSessions, state } = useTasks()

  const showModal = ref(false)
  const edit = ref<CalibrationSession>()

  const editCalibrationSession = (session: CalibrationSession) => {
    edit.value = session
    showModal.value = true
  }

  const closeModal = () => {
    showModal.value = false
    edit.value = undefined
  }

  const deleteCalibrationSession = async (item: CalibrationSession) => {
    const { isConfirmed } = await alertDialog(i18n.t('conversations.filters.calibrations.delete_modal.body'), {
      title: i18n.t('conversations.filters.calibrations.delete_modal.title', { sessionName: item.title }),
      confirmButtonText: i18n.t('conversations.filters.calibrations.delete_modal.confirm'),
      redConfirmButton: true,
    })

    if (!isConfirmed) return

    await apiDeleteCalibrationSession(session.workspace.id, item.sessionId)
    track('Calibration session deleted', { type: item.sessionId === calibrationSessionId.value ? 'active' : 'old' })

    await getCalibrationSessions()

    router.push(
      !state.allCalibrationSessions.length
        ? { name: 'tasks' }
        : {
            name: 'tasks.calibrations.review',
            params: { calibrationSessionId: state.allCalibrationSessions[0]?.sessionId },
          },
    )
  }

  return {
    showModal,
    edit,
    closeModal,
    editCalibrationSession,
    deleteCalibrationSession,
    canSeeCalibrations,
  }
})
